import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { FilePdfOutlined, FileWordOutlined } from '@ant-design/icons';
import { Col, Image, Row } from 'antd';
import { Box, Flex } from 'atoms';
import { getSignedUrl } from 'store/commonSlice';
import DownloadFiles from './DownloadFiles';

export default function ImageView({ entity, files = [], name }) {
	const dispatch = useDispatch();
	const [downloadLinks, setDownloadLinks] = useState([]);
	const [checkimageType, setImageType] = useState('');
	const imageTypes = ['jpeg', 'png', 'gif', 'jpg'];
	const pdfTypes = ['pdf'];
	const docTypes = ['doc', 'docx'];
	const [checkPDFType, setPDFType] = useState('');
	const [checkDocType, setDocType] = useState('');

	useEffect(() => {
		if (files?.length > 0) {
			const data = {
				url_type: 'view',
				data: {
					entity,
					keys: files,
				},
			};

			dispatch(getSignedUrl(data)).then((res) => {
				setDownloadLinks(res?.data);
				checkFileType(res?.data[0]?.filename);
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [entity, files]);

	if (files?.length === 0 || downloadLinks?.length === 0) {
		return null;
	}

	// eslint-disable-next-line react-hooks/exhaustive-deps
	function checkFileType(file) {
		const extType = file.split('.').pop();
		console.log(extType);
		setImageType(imageTypes.includes(extType));
		setPDFType(pdfTypes.includes(extType));
		setDocType(docTypes.includes(extType));
	}

	return (
		<Flex>
			{/* <Box backgroundColor="#fff" textAlign="right" padding="1.5rem">
				Upload: {name}
			</Box> */}
			{checkimageType &&
				downloadLinks?.map((item) => (
					// {}
					<Box key={item?.key} cursor="pointer" title={item?.filename}>
						<Image
							width={200}
							src={item.url}
							placeholder={<Image preview src={item.url} width={200} />}
						/>
						<Box backgroundColor="#fff" textAlign="right" padding="1.5rem"></Box>
						<DownloadFiles entity={entity} files={files} />
						<Row gutter={16} justify="space-between">
							<Col lg={8}></Col>
							<Col lg={16}></Col>
						</Row>
					</Box>
				))}
			{!checkimageType &&
				downloadLinks?.map((item) => (
					<Box key={item?.key} cursor="pointer" title={item?.filename}>
						{checkPDFType && (
							<FilePdfOutlined
								style={{
									color: 'red',
									fontSize: '50px',
									margin: '20px 20px',
									position: 'relative',
									zIndex: '999',
								}}
								name={name}
							/>
						)}
						{checkDocType && (
							<FileWordOutlined
								style={{
									color: 'blue',
									fontSize: '50px',
									margin: '20px 20px',
								}}
								name={name}
							/>
						)}

						<DownloadFiles entity={entity} files={files} name={name} />
						{/* <Row gutter={16} justify="space-between">
							<Col lg={12}></Col>
							<Col lg={12}></Col>
						</Row> */}
					</Box>
				))}
		</Flex>
	);
}

ImageView.propTypes = {
	entity: PropTypes.string,
	files: PropTypes.array,
	name: PropTypes.string,
};
